/* RN 하드웨어 백 버튼 처리를 위한 핸들러 스택 (LIFO).
   팝업/모달이 열릴 때 닫기 함수를 등록하면, 백 버튼 시 가장 최근에 열린
   팝업부터 닫힌다. (라우터 이동/앱 종료보다 우선) */

const stack = [];

/** 백 핸들러 등록 — 해제 함수 반환 (보통 useEffect cleanup 으로 사용) */
export function registerBackHandler(fn) {
  if (typeof fn !== 'function') return () => {};
  stack.push(fn);
  return () => {
    const i = stack.lastIndexOf(fn);
    if (i >= 0) stack.splice(i, 1);
  };
}

/** 등록된 핸들러가 있으면 가장 최근 것 1개 실행 후 true, 없으면 false.
    핸들러가 팝업을 닫으면 언마운트되며 cleanup 으로 스택에서 자동 제거된다. */
export function runTopBackHandler() {
  const fn = stack[stack.length - 1];
  if (typeof fn !== 'function') return false;
  try { fn(); } catch { /* ignore */ }
  return true;
}

/** 현재 등록된 백 핸들러 수 (열려있는 팝업 수) */
export function backHandlerCount() {
  return stack.length;
}
